import { useLocation, Link } from "react-router-dom";
import { Home, DollarSign, MessageSquare, Activity } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const tabs = [
  { to: "/professional/dashboard", icon: Home, label: "Home" },
  { to: "/professional/activity", icon: Activity, label: "Activity" },
  { to: "/wallet", icon: DollarSign, label: "Earnings" },
  { to: "/inbox", icon: MessageSquare, label: "Inbox" },
];

const ProBottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.account_mode !== "professional" || user?.professional_status !== "approved") return null;
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-200 safe-area-bottom" data-testid="pro-bottom-nav">
      <div className="max-w-3xl mx-auto flex items-center justify-around h-14">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.to || (tab.to === "/professional/dashboard" && location.pathname.startsWith("/professional/dashboard"));
          const Icon = tab.icon;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              onClick={() => window.dispatchEvent(new Event("close-mobile-menu"))}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${isActive ? "text-emerald-600" : "text-stone-400 hover:text-stone-600"}`}
              data-testid={`bottom-nav-${tab.label.toLowerCase()}`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
              <span className={`text-[10px] ${isActive ? "font-semibold" : "font-medium"}`}>{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default ProBottomNav;
